import { useState } from "react";
import ArtworkModal from "../ArtworkModal";
import Spinner from "../Spinner";
import { FreshenerSideBySide } from "./FreshenerSideBySide";
import { FreshenerOneView } from "./FreshenerOneView";
import { HeaderCardOneView } from "./HeaderCardOneView";
import { cn } from "@/utils";
import { CustomShapeView } from "./CustomShapeView";
import { DesignShape } from "@/types";
import { isDesignCustomShape } from "@/utils/customShape";

const ItemDesignDisplay = ({
  item,
  isLoadingImage,
  isLoadingHCImage,
  showEdit = false,
  size = "large",
  className,
  allowAddHC = false,
}: {
  item: {
    design: {
      id: string;
      front_proof: string;
      back_proof: string;
      shape: DesignShape;
    };
    hcard_design?: {
      id: string;
      front_proof: string;
      back_proof: string;
      shape: DesignShape;
    };
  };
  isLoadingImage: boolean;
  isLoadingHCImage: boolean;
  showEdit?: boolean;
  size?: "small" | "large";
  className?: string;
  allowAddHC?: boolean;
}) => {
  const [openArtworkModal, setOpenArtworkModal] = useState(false);
  const isCustomShape = isDesignCustomShape(item.design);

  return (
    <>
      <div className={cn("flex flex-row items-center justify-start space-x-2 relative", className)}>
        {(isLoadingImage || isLoadingHCImage) && (
          <div className="absolute flex w-full justify-center z-10">
            <Spinner className="h-10 w-10 text-gray-500" />
          </div>
        )}
        {isCustomShape ? (
          <CustomShapeView item={item} onClick={() => setOpenArtworkModal(true)} size={size} />
        ) : (
          <>
            {item.hcard_design ? (
              <div className="flex  gap-2">
                <FreshenerOneView
                  item={item}
                  onClick={() => setOpenArtworkModal(true)}
                  size={size}
                />
                <HeaderCardOneView
                  item={item}
                  onClick={() => setOpenArtworkModal(true)}
                  size={size}
                />
              </div>
            ) : (
              <FreshenerSideBySide
                item={item}
                onClick={() => setOpenArtworkModal(true)}
                size={size}
              />
            )}
          </>
        )}
      </div>

      <ArtworkModal
        open={openArtworkModal}
        setOpen={setOpenArtworkModal}
        item={item}
        showEdit={showEdit}
        showDelta={false}
      />
    </>
  );
};

export default ItemDesignDisplay;
